import ReactGA from 'react-ga4'
import DEFAULT from '../../config/default'

const GoogleAnalytics = () => {

    if (!DEFAULT.project.googleAnalytics) {
        return null
    }

    ReactGA.initialize([{
            trackingId: DEFAULT.project.googleAnalytics
    }])

    return null
}

export default GoogleAnalytics
